import axios from "axios";
import {
    CONTACT_US_REQUEST,
    CONTACT_US_SUCCESS,
    CONTACT_US_FAIL,
    

} from "../constants/categoryConstants";
import { BASE_URL, CONTACT_US_URL } from "../api";



/* ACTION CREATOR USED IN USER REGISTRATION IN RegisterScreen COMPONENT & HEADER */
export const contactUs = (name, email, subject, message) => async (dispatch) => {
    try {
      dispatch({
        type: CONTACT_US_REQUEST,
      });
  
      /* MAKE POST REQUEST TO GET BACK THE USER TOKEN */
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
  
      const { data } = await axios.post(
        BASE_URL+CONTACT_US_URL,
        { name: name, email: email, subject: subject,message: message, },
        config
      );
  
      /* IF POST REQUEST SUCCESSFULL WE DISPATCH & SEND THE PAYLOAD TO OUR REDUCER */
      dispatch({
        type: CONTACT_US_SUCCESS,
        payload: data,
      });
  
      /* AFTER REGISTRATION WE WANT TO IMMEDIATELY LOGIN THE USER */
    //   dispatch({
    //     type: USER_LOGIN_SUCCESS,
    //     payload: data,
    //   });
  
      /* SETTING VALUE OF USER INFO IN LOCAL STORAGE SO WE KNOW USER IS LOGGED IN */
    //   localStorage.setItem("userInfo", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: CONTACT_US_FAIL,
        payload:
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
      });
    }
  };
 